'use client';

import { FC } from 'react';

import { useAuthentication } from '@ravago/shared/authentication';
import { NavItem } from '@ravago/shared/radiance/components/navigation/components/NavItem/NavItem';
import { useTranslations } from '@ravago/shared/translations/client';

import { DataTestSelector } from '../../../utils/format/format.utils';

interface Props {
   hideLabel?: boolean;
   cyLabel?: string;
   onClick?: () => void;
}

export const LogoutButton: FC<Props> = ({ hideLabel, cyLabel, onClick }) => {
   const { user, logout } = useAuthentication();
   const translate = useTranslations();

   const handleSignOut = () => {
      onClick?.();
      logout();
   };

   if (!user) return null;

   return (
      <NavItem attributes={{ ...(cyLabel && { ...DataTestSelector(cyLabel) }) }} size="md" icon="sign-out" color={4} onClick={handleSignOut}>
         {!hideLabel && translate('page-consumer.header.account.sign-out')}
      </NavItem>
   );
};
